export class WorkOrderProposalAcceptParametersDto {
    workOrderProposalId: number;
    acceptedFileIds: Array<number>;
    communityId: number;
    workOrderId: number;
}
